<script>
import { GetUserData } from "./APIService";
import { UserData } from './UserStore.js';

let inputText = "";

let selectedOption = 'Id';

function _GetUserData() {
  GetUserData(selectedOption, inputText, () => inputText = "");
}

function onKeyDown(e){
  if (inputText == "") {
    return;
  }
  switch(e.keyCode) {
			 case 13:
          _GetUserData()
				 break;
		 }
}

$: console.log('Changed selected:', selectedOption)

</script>


<div class="card col-md-12">
  <h5 class="card-header"><h3>Find</h3></h5>
  <div class="card-body">
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio0" value="Id" bind:group={selectedOption} checked>
      <label class="form-check-label" for="inlineRadio0">Id</label>
    </div>
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="Username" bind:group={selectedOption}>
      <label class="form-check-label" for="inlineRadio1">Username</label>
    </div>
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="Email" bind:group={selectedOption}>
      <label class="form-check-label" for="inlineRadio2">Email</label>
    </div>
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio3" value="ReferralCode" bind:group={selectedOption}>
      <label class="form-check-label" for="inlineRadio3">ReferralCode</label>
    </div>
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio4" value="DeviceId" bind:group={selectedOption}>
      <label class="form-check-label" for="inlineRadio4">DeviceId</label>
    </div>
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio4" value="PhoneNumber" bind:group={selectedOption}>
      <label class="form-check-label" for="inlineRadio4">PhoneNumber</label>
    </div>
  
    <div class="input-group mb-3">
        <input type="text" class="form-control" bind:value={inputText} >
        <div class="input-group-append">
          <button class="w-100 btn btn-lg btn-primary" on:click={_GetUserData}>Get</button>
        </div>
    </div>
  </div>
</div>


<hr />

<svelte:window on:keydown={onKeyDown} />


<style>
  .card{
      margin: 5px;
  }
</style>
